import styled from 'styled-components';

const BonusLabelWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export default BonusLabelWrapper;
